import { fetchApplication as fetchApi } from "./api";
import { Version } from "../store/myAxis/types";
import { AxiosResponse } from "axios";

const APPLICATION = "applications";
const FIRMWARE = "firmware";


export async function fetch(): Promise<AxiosResponse<any>> {
  return fetchApi({
    nestedResourcePath: [APPLICATION],
    // id: id,
    // params: params
  }).then(response => response.data);
}

export async function fetchFirmwareData(params: { variant: string; model: string }): Promise<AxiosResponse<any>> {
  return fetchApi({
    nestedResourcePath: [FIRMWARE],
    // id: id,
    params: params
  }).then(response => response.data);
}

export async function fetchVersionData(application: string): Promise<Version> {
  try {
    const resourcePath = APPLICATION + '/' + application;
    const resourcePathVersion = APPLICATION + '/' + application + '/versions';
    const [applicationData, versions] = await Promise.all([
      fetchApi({
        nestedResourcePath: [resourcePath],
      }),
      fetchApi({
        nestedResourcePath: [resourcePathVersion],
      }),
    ]);
    return {
      applicationData: applicationData.data,
      versions: versions.data,
      application
    }
  } catch (e) {
    return e;
  }
}
